(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    	.controller('AccountController', account);

  account.$inject = ['$scope', '$http', '$rootScope', '$stateParams', '$location', '$timeout', 'UserService', 'FoundationApi', 'Upload', 'AuthenticationService'];

  function account ($scope, $http, $rootScope, $stateParams, $location, $timeout, UserService, FoundationApi, Upload, AuthenticationService) {
    var vm = this;

    UserService.find({ id: $rootScope.user_data.id }, function (data) {
      vm.user = data;
    }, function (error) {

    });
    vm.saveUser = function (user) {
      UserService.updateMyAccount({
        id: vm.user.id
      }, vm.user,
      function (data) {
        FoundationApi.publish('main-notifications', { title: $rootScope.labels.saved, content: $rootScope.labels.sucUpdDatas, autoclose: '3000', color: 'success' });
      }, function (error) {
        var message = $rootScope.labels.errorProcReq;
        if (error) {
          if (error.data) {
            if (error.data.message) { message = error.data.message; }
          }
        }
        FoundationApi.publish('main-notifications', { title: $rootScope.labels.error, content: message, autoclose: '3000', color: 'alert' });
      });
    }
    vm.changePassword = function () {
      UserService.changePassword({ password: vm.password },
        function (response) {
          if (response.error) {
            FoundationApi.publish('main-notifications', { title: $rootScope.labels.errorForm, content: response.message, autoclose: '3000', color: 'alert' })
            return
          }
          AuthenticationService.SetCredentials(response.email, response.auth_token)
          FoundationApi.publish('main-notifications', { title: $rootScope.labels.changedPassw, content: $rootScope.labels.sucUpdPassw, autoclose: '3000', color: 'success' })
          vm.password = null
        }, function (error) {
          FoundationApi.publish('main-notifications', { title: $rootScope.labels.error, content: $rootScope.labels.errorUpdPassw, autoclose: '3000', color: 'alert' })
        })
    }

    vm.uploadFiles = function (file, index) {
      if (file) {
        if (file.length) {
          var params = {};
          params.company_id = $stateParams.id;
          params.id = $rootScope.user_data.id;
          file.upload = Upload.upload({
            url: apiUrl + '/profile-picture-upload',
            fields: params,
            file: file
          });

          file.upload.then(function (response) {
            $timeout(function () {
              $rootScope.user_data.profile_picture_path = response.data.url;
            });
          }, function (response) {
            if (response.status > 0) { var message = $rootScope.labels.errorProcReq; }
            if (response) {
              if (response.data) {
                if (response.data.message) { message = response.data.message; }
              }
            }
            FoundationApi.publish('main-notifications', { title: $rootScope.labels.error, content: message, autoclose: '3000', color: 'alert' });
          });
        }
      }
    };
  }
})();
